// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"384eab0d","305":"6572d6fa","585":"6572d6fa","649":"1a49ba2e","741":"95f3b6d4","835":"474e22c5","895":"a5a292ec"}[chunkId] + ".chunk.css";
};